const { createSlice } = require("@reduxjs/toolkit");

const pageTitleSlice = createSlice({
    name: "pageTitle",
    initialState: {
        data: 'Home',
        status: 'idle',
        error: null,
    },
    reducers: {
        setPageTitle: (state, action) => {
            state.data = action.payload;
        },
    },
});

export const { setPageTitle } = pageTitleSlice.actions;

export default pageTitleSlice.reducer;